import { useCallback } from 'react';

import useDispatchNumberLabel from '~hooks/useDispatchNumberLabel';

export default function useDispatchNumberFilterLabel() {
  const { plural } = useDispatchNumberLabel();

  return useCallback(
    (isDispatchNumberFilter: boolean, fallbackLabel: string) =>
      isDispatchNumberFilter
        ? plural('dispatch.dispatch_v2.filters.dispatch_numbers')
        : fallbackLabel,
    [plural],
  );
}
